import { useEffect, useState } from "react"
import TranslationUploadFile from "./TranslationUploadFile"
import TranslationPreview from "./TranslationPreview"
import "./Translation.scss"
import documentApi, { DocumentDetailDTO, DocumentDTO } from "../api/document.api"
import { useMask } from "../components/mask/Mask"
import Env from "../../Env"
import LoadingIcon from "../components/icon/LoadingIcon"
import { Flex } from "antd"
import Icon from "../components/icon/Icon"
const steps = [
    "Upload file",
    "Preview translation file",
]
import checkCircleSvg from "./assets/images/check-circle.png"
import { useNavigate } from "react-router-dom"
import { getTranslation, useTranslate } from "../components/language"

export default (props: {docId?: string}) => {
    `
    1. 新增了一个translation_progress_percentage，GET documents 和 GET /documents/{id} 都会有这个字段。 它会返回当前的翻译进度
    2. 付费后继续翻译也支持了，当document处于 “WAITING_PAYMENT”就是完成了sample翻译需要付费。付费可以使用stripe testcard https://docs.stripe.com/testing#cards

    3. document 现有状态

    class BaseTaskStatus(str, Enum):

        PENDING = "PENDING"
        IN_PROGRESS = "IN_PROGRESS" //只有此时，有翻译进度，其他不是100 就是 0
        WAITING_PAYMENT = "WAITING_PAYMENT"
        COMPLETED = "COMPLETED"
        FAILED = "FAILED"
    `
    
    const [step, setStep] = useState<number>(0)
    const {render: maskRender, show: showProgress, close: closeProgress} = useMask()
    const [docId, setDocId] = useState<string>()
    const navigate = useNavigate()
    const { t } = useTranslate();

    const onComplete = async (doc: DocumentDetailDTO) => {
        Env.DEBUG && console.log("onComplete")
        closeProgress()
        //获取预览页面
        // setDocId(doc.id)
        // setStep(1)
        // documentApi.checkout({id: doc.id})
        navigate(`/app/preview?docId=${doc.id}`, {
            replace: true,
        })
    }

    const onCreateHandler = (doc: DocumentDTO) => {

        // Env.DEBUG && console.log("doc:", doc)
        // showProgress(<TranslateProgress docId={doc.id} onComplete={onComplete}/>)
        navigate("/app")
    }

    const renderContent = () => {
        switch (step) {
            case 0:
                return (
                    <TranslationUploadFile onCreate={onCreateHandler} />
                )
            case 1:
                if(docId){
                    return (
                        <TranslationPreview docId={docId} />
                    )
                }else{
                    return (
                        <LoadingIcon />
                    )
                }
        }
    }

    useEffect(() => {
        // setDocId("687b2d3aeafab5b69ba5f7e1")
        // setStep(1)
        if(props.docId){
            setDocId(props.docId)
            setStep(1)
        }
    }, [props])


    return (
        <div className="translation">
            <div className="wizard">
                    <div className="title">{t("My Process")}</div>
                    <div className="items">
                    {
                        steps.map((item, index) => {
                            if(index < step){
                                return (
                                    <div 
                                    key={index} 
                                    className={["item", ""].join(" ")}
                                    >
                                        <Flex align="center" justify="space-between" style={{width: "100%"}}>
                                            {t(item)}
                                            <Icon src={checkCircleSvg} size={20}></Icon>
                                        </Flex>
                                    </div>

                                )
                            }else if(index == step){
                                return (
                                    <div 
                                    key={index} 
                                    className={["item", "highlight"].join(" ")}
                                    >{t(item)}</div>
                                )
                            }else{
                                return (
                                    <div 
                                    key={index} 
                                    className={["item", ""].join(" ")}
                                    >{t(item)}</div>
                                )
                            }
                            
                        })
                    }
                    </div>
                    
            </div>
            <div className="content">
                {renderContent()}
            </div>
            {maskRender}
        </div>
    )
}


const TranslateProgress = (props: {docId: string, onComplete: (doc: DocumentDetailDTO) => void}) => {

    const size = 64
    const strokeWidth = 6

    
    
    // 计算圆环半径和周长
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    

    const [progress, setProgress] = useState<number>(0)
    const {
        docId,
        onComplete
    } = props

    const getStrokeDashoffset = () => {
        // 确保进度在 0-100 之间
        const normalizedProgress = Math.min(Math.max(progress, 0), 100);
        const strokeDashoffset = circumference - (normalizedProgress / 100) * circumference;
        return strokeDashoffset
    }

    useEffect(() => {
        const scheduleId = setInterval(() => {
            documentApi.detail({id: docId}).then(res => {
                //快速完成
                if(res.status === "WAITING_PAYMENT"){
                    //完成了
                    clearInterval(scheduleId)
                    onComplete(res)
                }else if(res.status === "IN_PROGRESS"){
                    //
                    setProgress(res.translation_progress_percentage??0)
                }
            })

        }, 1000);
    }, [])

    return (
        <div className="translate-progress">
            <div className="progress-ring-container" style={{ width: size, height: size }}>
                <svg className="progress-ring" width={size} height={size}>
                    {/* 背景圆环 */}
                    <circle
                    className="progress-ring-circle-bg"
                    stroke={"#EAECF0"}
                    strokeWidth={strokeWidth}
                    fill="transparent"
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                    />
                    {/* 进度圆环 */}
                    <circle
                    className="progress-ring-circle"
                    stroke={"#63ABA2"}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    fill="transparent"
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
                    style={{
                        strokeDasharray: `${circumference} ${circumference}`,
                        strokeDashoffset: getStrokeDashoffset(),
                        transform: `rotate(-90deg)`,
                        transformOrigin: '50% 50%',
                    }}
                    />
                </svg>
                <div className="progress-text">{progress}%</div>
            </div>
            
            <div className="b">
                <div className="title">Translating your file...</div>
                <div className="description">We are working on your file. This usually takes just a moment.</div>
            </div>            
        </div>
    )
}